module.exports = __webpack_public_path__ + "img/update3.5_image03.e6076539.png";